import React, { useRef } from 'react';
import { Formik, Form, Field, CccisdInput } from 'cccisd-formik';
import Modal from 'cccisd-modal';
import axios from 'cccisd-axios';
import notification from 'cccisd-notification';
import IconAdd from 'cccisd-icons/plus2';

const Boilerplate = window.cccisd.boilerplate;

export default function AddRespondent({ deployment, disabled = false, onSubmitSuccess }) {
    const addResModal = useRef(null);

    const closeModal = () => {
        if (addResModal.current) {
            addResModal.current.close();
        }
    };

    const handleCancel = () => {
        closeModal();
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            if (!deployment?.deploymentId) {
                notification({
                    type: 'danger',
                    message: 'Please select a site before adding a respondent.',
                });
                return;
            }

            // groupId can come from a deployment assignment or an explicit prop from parent.
            const groupId = deployment?.assignment?.groupId || deployment?.groupId;

            if (!groupId) {
                notification({
                    type: 'danger',
                    message: 'Unable to resolve the selected site. Please re-select a site.',
                });
                return;
            }

            const payload = {
                ...values,
                activate: false,
                role: 'respondent',
                first_name: values.firstName,
                last_name: values.lastName,
                group: groupId,
            };

            const response = await axios.post(Boilerplate.route('api.nexus.pawn.store'), payload);
            const pawnId = response?.data?.data?.id || null;

            // @todo - handle error case where respondent creation fails and pawnId is not returned
            await axios.post(
                Boilerplate.route('api.assignmentDeploymentRespondent.store', {
                    deploymentId: deployment.deploymentId,
                }),
                {
                    pawnIds: [pawnId],
                }
            );

            // @todo if respondentResponse has errors, delete created pawn
            closeModal();

            if (typeof onSubmitSuccess === 'function') {
                await onSubmitSuccess();
            }
        } catch (error) {
            notification({
                type: 'danger',
                message: 'Unable to add respondent. Please try again.',
            });
            throw error;
        } finally {
            setSubmitting(false);
        }
    };

    const validate = values => {
        const errors = {};
        if (!values.username) {
            errors.username = 'Username is required';
        }
        if (!values.firstName) {
            errors.firstName = 'First name is required';
        }
        if (!values.lastName) {
            errors.lastName = 'Last name is required';
        }
        return errors;
    };

    return (
        <Modal
            ref={addResModal}
            title="Add Respondent"
            trigger={
                <button type="button" className="btn btn-primary" disabled={disabled}>
                    <IconAdd spaceright /> Add Respondent
                </button>
            }
        >
            <Formik
                initialValues={{
                    username: '',
                    firstName: '',
                    lastName: '',
                }}
                validate={validate}
                onSubmit={handleSubmit}
                render={({ isSubmitting }) => (
                    <Form>
                        <div className="form-group">
                            <label htmlFor="firstName">First Name</label>
                            <Field id="firstName" name="firstName" type="text" component={CccisdInput} />
                        </div>

                        <div className="form-group">
                            <label htmlFor="lastName">Last Name</label>
                            <Field id="lastName" name="lastName" type="text" component={CccisdInput} />
                        </div>

                        <div className="form-group">
                            <label htmlFor="username">Username</label>
                            <Field id="username" name="username" type="text" component={CccisdInput} />
                        </div>

                        <div className="d-flex justify-content-between" style={{ marginTop: '15px' }}>
                            <button type="button" onClick={handleCancel} className="btn btn-secondary">
                                Cancel
                            </button>
                            <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                                Add Respondent
                            </button>
                        </div>
                    </Form>
                )}
            />
        </Modal>
    );
}
